module.exports = __webpack_public_path__ + "assets/check.92d34bc4.svg";